<script setup lang="ts">
const { t } = useI18n();
</script>

<template>
  <div class="flex items-center justify-center flex-row-reverse max-lg:px-4 max-lg:py-10 text-center lg:flex-row max-lg:mb-24">
    <BaseButton
      name="sign-in"
      type="icon"
      tag="nuxt-link"
      :title="t('labels.sign_in')"
      :to="{ path: '/auth/login/' }"
      class="mx-6 text-button-bold text-main w-full lg:w-auto lg:flex-shrink-0"
    >
      {{ t('labels.sign_in') }}
    </BaseButton>
    <BaseButton
      name="sign-up"
      tag="nuxt-link"
      class="text-button-bold w-full lg:w-auto lg:flex-shrink-0"
      :title="t('labels.sign_up')"
      :to="{ path: '/auth/sign-up/' }"
    >
      {{ t('labels.sign_up') }}
    </BaseButton>
  </div>
</template>
